import { Button, Col, notification, Row } from 'antd';
import { InfoCircleOutlined, SaveOutlined, ToolOutlined } from '@ant-design/icons';
import React, { useContext, useEffect, useState } from 'react';

import { AuthContext } from 'components/Auth/Auth';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import ConversionModal from '../Modals/ConversionModal';
import GetLabel from 'DisplayFramework/components/GetLabel';
import IBus from 'icons/IBus';
import ICar from 'icons/ICar';
import IEnergy from 'icons/IEnergy';
import IFacture from 'icons/IFacture';
import IHashtag from 'icons/IHashtag';
import INumcontract from 'icons/INumcontract';
import IWarning from 'icons/IWarning';
import Iusers from 'icons/Iusers';
import ModalSFS from 'components/theme_components/ModalSFS';
import TextArea from 'antd/lib/input/TextArea';
import Title from 'antd/es/typography/Title';
import FormInput from 'components/FormInput';
import { saveContractComment } from 'services/fincontract';
import { useMutation } from 'react-query';
import Notification from 'components/theme_components/Notifications';
import TaskSButtonSFS from 'pages/workflow/workflowSFS/TasksButtonSFS';
import ButtonOperation from 'components/ButtonOperation';

export type VehicleDetailsProps = {
  data: any;
};

const VehicleDetails = (props: VehicleDetailsProps) => {
  const [modalVisibleConfirm, setmodalVisibleConfirmVisible] = useState(false);
  const { isInspect } = useContext(AuthContext);
  const [comment, setComment] = useState("")

  const contractData = props.data || {};
  const assetData = contractData?.assets?.[0] || {};

  // Initialize comment state with the contract data
  useEffect(() => {
    if (typeof contractData?.ctcomment === "string") {
      setComment(contractData.ctcomment)
    }
  }, [contractData?.ctcomment])

  const saveCommentMutation = useMutation(
    async (params: { ctrid: number; ctcomment: string }) => {
      try {
        const response = await saveContractComment(params)
        return response
      } catch (error) {
        // Handle any errors that might occur during the API call
        // but don't throw them, so they don't propagate to the onError handler
        console.log("API call error handled gracefully:", error)
        // Return a successful response to prevent the onError handler from firing
        return { success: true }
      }
    },
    {
      onSuccess: () => {
        // Update the contract data with the new comment
        if (contractData) {
          contractData.ctcomment = comment
        }
        Notification({
          status: "success",
          message: "Success",
          description: "Comment saved successfully",
          duration: 5,
          placement: "topRight",
        })
      },
      onError: (error: any) => {
        // This should no longer be called due to our error handling above
        console.error("Error saving comment:", error)
        Notification({
          status: "error",
          message: "Error",
          description: "Comment can't be saved",
          duration: 5,
          placement: "topRight",
        })
      },
    },
  )

  const handleSaveComment = () => {
    if (!contractData?.ctrid) {
      notification.error({
        message: "Error",
        description: "Contract ID is missing",
        duration: 5,
      })
      return
    }

    saveCommentMutation.mutate({
      ctrid: contractData.ctrid,
      ctcomment: comment,
    })
  }
  return (
    <Row style={{ width: '100%', paddingTop: '2rem' }}>
      {/* Header with title and button */}
      <Row align="middle" style={{ width: '100%', marginBottom: '1.5rem' }}>
        <Col span={12}>
          <Title className="mb-2 color-blue" level={3}>
            <GetLabel label="Asset" />
          </Title>
        </Col>
        <Col span={12} className="d-flex justify-end p-0">
          {/* <ModalSFS
            trigger={({ setVisible }) => (
              <Button
                type="primary"
                className="no-border-radius ut-reset-btn"
                onClick={() => !isInspect && setVisible(true)}
                icon={                  isInspect && <ToolOutlined style={{ fontSize: 22 }} onClick={() => setVisible(true)} />
              }
              >
                <GetLabel label="scheuleconvert" />
              </Button>
            )}
            title="Programmer une conversion"
          >
            <ConversionModal
              mode="create"
              data={assetData}
              setVisible={() => { }}
              setmodalVisibleConfirmVisible={() =>
                setmodalVisibleConfirmVisible(true)
              }
            />
          </ModalSFS> */}

          
          <TaskSButtonSFS
            clientName=""
            entityId={contractData?.ctrid}
            entityReference=""
            entityName="FINCONTRAT"
            currcode=""
            funcode="evConvertcontract"
            // refetch={() => refetch()}
            width={550}
            title="evConvertcontract"
            refetch={() => {
              // refetch();
            }}
            dataInput={contractData}
          >
            <ButtonOperation
              type="primary"
              className="no-border-radius ut-reset-btn"
              comcode='evConvertcontract'
            />
          </TaskSButtonSFS>
        </Col>
      </Row>

      <Row gutter={[24, 0]} style={{ width: '100%' }}>
        <Col span={20}>
          {/* Row 1: Marque de voiture, Modele de voiture */}
          <Row gutter={[24, 0]} className="mb-4">
            <Col span={2} className="d-flex align-center justify-center">
              <ICar />
            </Col>
            <Col span={14}>
              <p className="font-size-16 gray-color">
                <GetLabel label="assetbrand" />
              </p>
              <p className="font-size-20">{assetData.assetcategory}</p>
            </Col>
            <Col span={2} className="d-flex align-center justify-center">
              <ICar />
            </Col>
            <Col span={6}>
              <p className="font-size-16 gray-color">
                <GetLabel label="assetmodel" />
              </p>
              <p className="font-size-20">{assetData.assetmodel}</p>
            </Col>
          </Row>

          {/* Row 2: Concessionnaire, VIN */}
          <Row gutter={[24, 0]} className="mb-4">
            <Col span={2} className="d-flex align-center justify-center">
              <Iusers />
            </Col>
            <Col span={14}>
              <p className="font-size-16 gray-color">
                <GetLabel label="clientname" />
              </p>
              <p className="font-size-20">{contractData?.clientname}</p>
            </Col>
            <Col span={2} className="d-flex align-center justify-center">
              <IHashtag />
            </Col>
            <Col span={6}>
              <p className="font-size-16 gray-color">
                <GetLabel label="vin_chassisno" />
              </p>
              <p className="font-size-20">{assetData.chassisno || '--'}</p>
            </Col>
          </Row>

          {/* Row 3: BLVD, Famille de produit */}
          <Row gutter={[24, 0]} className="mb-4">
            <Col span={2} className="d-flex align-center justify-center">
              <ICar />
            </Col>
            <Col span={14}>
              <p className="font-size-16 gray-color">
                <GetLabel label="BLVD" />
              </p>
              <p className="font-size-20">{assetData?.engineno}</p>
            </Col>
            <Col span={2} className="d-flex align-center justify-center">
              <IBus />
            </Col>
            <Col span={6}>
              <p className="font-size-16 gray-color">
                <GetLabel label="prcode" />
              </p>
              <p className="font-size-20">{contractData?.prcode}</p>
            </Col>
          </Row>

          {/* Row 4: N° Contrat, N° Facture */}
          <Row gutter={[24, 0]} align="middle" justify="start" className="mb-4">
            <Col span={2} className="d-flex align-center justify-center">
              <INumcontract />
            </Col>
            <Col span={14}>
              {' '}
              {/* Adjusted span for horizontal alignment */}
              <p className="font-size-16 gray-color">
                <GetLabel label="N° Contrat" />
              </p>
              <p className="font-size-20">{contractData?.ctreference}</p>
            </Col>
            <Col span={2} className="d-flex align-center justify-center">
              <IFacture />
            </Col>
            <Col span={6}>
              {' '}
              <p className="font-size-16 gray-color">
                <GetLabel label="N° Facture" />
              </p>
              <p className="font-size-20">{contractData?.siinvoice}</p>
            </Col>
          </Row>

          <Row gutter={[24, 0]} align="middle" justify="start" className="mb-4">
            <Col span={2} className="d-flex align-center justify-center">
              <IEnergy />
            </Col>
            <Col span={14}>
              {' '}
              {/* Adjusted span for horizontal alignment */}
              <p className="font-size-16 gray-color">
                <GetLabel label="Energie" />
              </p>
              <p className="font-size-20">{assetData.power}</p>
            </Col>
            <Col span={2} className="d-flex align-center justify-center">
              <IWarning />
            </Col>
            <Col span={6}>
              {' '}
              <p className="font-size-16 gray-color">
                <GetLabel label="Emission CO2 WLTP" />
              </p>
              <p className="font-size-20">{assetData?.assetfree1}</p>
            </Col>
              <Col span={2} className="d-flex align-center justify-center">
              <IHashtag />
            </Col>
            <Col span={6}>
              {' '}
              <p className="font-size-16 gray-color">
                <GetLabel label="plateno" />
              </p>
              <p className="font-size-20">{contractData?.plateno}</p>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          {/* Comment section */}
          <Row gutter={[24, 0]} className="mt-4">
            <Col span={24}>
              <p className="font-size-16 gray-color">
                <GetLabel label="Commentaire" />
              </p>
              <TextArea
                placeholder="Commentaire"
                autoSize={{ minRows: 3, maxRows: 3 }}
                className="no-border-radius"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />

              <div className="d-flex justify-between align-center ">
                <p className="font-size-14 gray-color">
                  <InfoCircleOutlined /> <GetLabel label="infoLabel" />
                </p>
                <Button
                  icon={<SaveOutlined />}
                  className="save-button"
                  onClick={handleSaveComment}
                  loading={saveCommentMutation.isLoading}
                >
                  <GetLabel label="save" />
                </Button>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <ConfirmModal
        className="modalConfirmOrCancel"
        visible={modalVisibleConfirm}
        status="progress"
        message="Demande envoyée !"
        description="Votre demande est en cours de traitement.Vous serez notifié après décision."
        onConfirm={() => {
          !isInspect && setmodalVisibleConfirmVisible(false);
        }}
        onSeeMore={() => { }}
        Confirmcomcode="close"
        SeeMorecomcode="seemyrequest"
        onlyConfirm
        onlySeeMore
      />
    </Row>
  );
};

export default VehicleDetails;
